import React from "react";
import SVG from "react-inlinesvg";
import { Col, Modal,Form, Nav, Row, Tab } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
    errorMessage,
    formatAmount,
    formatDate,
    formatStatus,
    permissionAllow,
} from "../../../../util/Helpers";
import { useDispatch, useSelector } from "react-redux";
import { useGetDocumentsQuery } from "../../../../../redux/apiSlice";
import { DocumentTab } from "../../../PendingKyc/pages/modal/sections/documents";
import PendingDocumentModalSkeleton from "../../../PendingKyc/pages/modal/PendingDocumentModalSkeleton";
import PaymentDocument from "../../../PendingKyc/pages/modal/sections/documents/PaymentDocument";
import { PermissionType } from "../../../../util/Permissions";

const CreationModal = ({ showViewCreationModal, details, onHide }) => {
    const { isLoading, data } = useGetDocumentsQuery(details);
    const adminUser = useSelector(state => state.auth.user);
    
    return (
        <Modal
            show={showViewCreationModal}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                        />
                    </span>
                    Documents
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2 pb-12"
            >
                <Tab.Container id="left-tabs-example" defaultActiveKey={""}>
                    <Row style={{ height: "calc(100vh - 220px)" }}>
                        <Col
                            sm={3}
                            className={"d-flex flex-column pl-0 border-right h-100"}
                        >
                            <div className={"flex-fill overflow-auto"}>
                                <Nav variant="pills">
                                    <Nav.Item className={"w-100"}>
                                        <Nav.Link eventKey={""}>
                                            <div>Details</div>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className={"w-100"}>
                                        <Nav.Link eventKey={"Supporting Documents"}>
                                            <div>Documents</div>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </Col>
                        <Col sm={9} className={"overflow-auto h-100"}>
                            <Tab.Content className={"h-100"}>
                                <Tab.Pane eventKey={""} className={"h-100"}>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Card ID</h6>
                                            <span className="text-muted">{details?.id}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Provider</h6>
                                            <span className="text-muted">{details?.provider}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Payment Ref</h6>
                                            <span className="text-muted">{details?.paymentRef}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Amount</h6>
                                            <span className="text-muted">{details?.amount}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6 className=" px">User ID</h6>
                                            <span className="text-muted">{details?.userId}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Card Type</h6>
                                            <span className="text-muted">{details?.payload?.cardType}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Status</h6>
                                            <span className="text-muted">{details?.status}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Conversion Rate</h6>
                                            <span className="text-muted">{details?.conversionRate}</span>
                                        </div>
                                        <div className="col-lg-4 py-4">
                                            <h6>Currency</h6>
                                            <span className="text-muted">{details?.currency}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Balance</h6>
                                            <span className="text-muted">{formatAmount(details?.currency, details?.payload?.balance)}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Mode</h6>
                                            <span className="text-muted">{details?.via}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Created</h6>
                                            <span className="text-muted">{formatDate(details?.created)}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Single Use</h6>
                                            <span className="text-muted">{details?.singleUse ? "True" : "False"}</span>
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey={"Supporting Documents"}  >

                                {
                                    isLoading
                                        ? <PendingDocumentModalSkeleton />


                                        : <Tab.Container id="left-tabs-example" defaultActiveKey={data?.docs[0]?.documentId}  >

                                            <Row className={"h-100 "} >

                                                <Col
                                                    sm={4}
                                                    className={"border-right h-100 overflow-auto"}
                                                >
                                                    <Nav className={"h-100 "} >
                                                        {data?.docs.map(({ documentId, type, status, document }) => (

                                                            <DocumentTab
                                                                key={documentId}
                                                                dataKey={documentId}
                                                                status={status}
                                                                src={document}
                                                                title={type.replaceAll("_", " ").toLowerCase()}
                                                            />
                                                        ))}
                                                    </Nav>

        
                                                </Col>

                                                <Col sm={8} className={"h-100 overflow-auto"} >
                                                    <Tab.Content className={"h-100"}>
                                                        {data?.docs.map((doc) => (
                                                            <Tab.Pane key={doc.documentId} eventKey={doc.documentId} style={{ height: "calc(100vh - 220px)" }}>
                                                                <PaymentDocument
                                                                    initialValues={doc}
                                                                    isEditable={permissionAllow(adminUser, Permissions.PENDING_KYC, PermissionType.UPDATE)}
                                                                />
                                                            </Tab.Pane>
                                                        ))}
                                                    
                                                        
                                                    </Tab.Content>
                                                </Col>
                                            </Row>


                                        </Tab.Container>
                                }

                            </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
        </Modal>

    );
}

export default CreationModal;